import React from 'react';

import type { SiteFooter } from '@swf/cms';
import { CMSHTML } from '@swf/cms';

import styles from './Copyright.scss';

interface Props {
  copyright: SiteFooter['copyright'];
}

const Copyright: React.FC<Props> = ({ copyright }) => (
  <CMSHTML content={copyright} className={styles.copyrightText} />
);

export default Copyright;
